import React, { useState } from 'react';
import { 
  Play, BookOpen, Clock, Star, Search, Filter, 
  ChevronRight, Lock, Award, GraduationCap, SearchX 
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import HeaderActions from '../components/HeaderActions';
import Footer from '../components/Footer';

// 🔥 DİL ENTEGRASYONU 🔥
import { useLanguage } from '../context/LanguageContext';

const AcademyPage = () => {
  const { t } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  // Örnek Eğitim Verileri
  const courses = [
    {
      id: 1,
      title: "Almanya'da Vergi Sistemi 101",
      category: "tax",
      duration: "45 min",
      level: "Başlangıç",
      rating: 4.8,
      students: 1240,
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&q=80&w=400",
      locked: false
    },
    {
      id: 2,
      title: "Freelancer Olma Rehberi",
      category: "business",
      duration: "1h 20m",
      level: "Orta",
      rating: 4.9,
      students: 850,
      image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=400",
      locked: false
    },
    {
      id: 3,
      title: "Şirket Kurulumu (GmbH & UG)",
      category: "business",
      duration: "2h 15m",
      level: "İleri",
      rating: 5.0,
      students: 320,
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=400",
      locked: true
    },
    {
      id: 4,
      title: "Oturum İzni ve Bürokasi",
      category: "legal",
      duration: "55 min",
      level: "Başlangıç",
      rating: 4.7,
      students: 2100,
      image: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&q=80&w=400",
      locked: false
    },
    {
      id: 5,
      title: "Yatırım ve Emeklilik Planı",
      category: "finance",
      duration: "1h 45m",
      level: "Orta",
      rating: 4.6,
      students: 560,
      image: "https://images.unsplash.com/photo-1579621970563-ebec7560eb3e?auto=format&fit=crop&q=80&w=400",
      locked: true
    }
  ];

  const categories = [
    { id: 'all', label: 'Tümü' },
    { id: 'tax', label: 'Vergi' },
    { id: 'business', label: 'İş Dünyası' },
    { id: 'legal', label: 'Hukuk' },
    { id: 'finance', label: 'Finans' }
  ];

  const filteredCourses = courses.filter(course => {
    const matchesCategory = activeCategory === 'all' || course.category === activeCategory;
    const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-[#0B1120] text-slate-100 font-sans pb-32 flex flex-col relative overflow-x-hidden">
      
      {/* HEADER */}
      <header className="relative z-50 sticky top-0 bg-[#0B1120]/80 backdrop-blur-xl border-b border-white/5 px-6 py-4">
        <div className="flex items-center justify-between max-w-[1600px] mx-auto">
          <div className="flex items-center gap-4">
            <div>
                <h1 className="text-xl md:text-2xl font-black tracking-tighter uppercase italic text-white leading-none">
                    {t('academy_title') || 'BüroFuchs Akademi'}
                </h1>
                <p className="text-[10px] font-bold text-slate-500 uppercase tracking-[0.2em] mt-1">Knowledge Base v2.0</p>
            </div>
          </div>
          <HeaderActions />
        </div>
      </header>

      <main className="flex-1 p-6 md:p-10 max-w-[1600px] mx-auto w-full relative z-10 space-y-12">
        
        {/* HERO SECTION */}
        <div className="relative rounded-[3rem] overflow-hidden bg-gradient-to-r from-blue-900 to-indigo-900 border border-white/10 p-10 md:p-16 text-center md:text-left">
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 mix-blend-overlay"></div>
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-[100px] pointer-events-none"></div>
            
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
                <div className="space-y-6 max-w-2xl">
                    <Badge className="bg-orange-500/20 text-orange-400 border-orange-500/30 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest">
                        Yeni Sezon Başladı
                    </Badge>
                    <h2 className="text-4xl md:text-6xl font-black text-white tracking-tighter leading-[0.9]">
                        ÖĞREN. <br/>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">UYGULA.</span> <br/>
                        KAZAN.
                    </h2>
                    <p className="text-lg text-blue-100/80 font-medium leading-relaxed">
                        Almanya'da finansal özgürlüğe giden yolda ihtiyacın olan tüm bilgiler burada. Netflix tadında eğitim serileri.
                    </p>
                    <div className="flex gap-4">
                        <Button className="h-14 px-8 rounded-2xl bg-white text-blue-900 hover:bg-blue-50 font-black uppercase tracking-widest text-xs">
                            Hemen Başla
                        </Button>
                        <Button variant="outline" className="h-14 px-8 rounded-2xl border-white/20 text-white hover:bg-white/10 font-black uppercase tracking-widest text-xs">
                            Kataloğu İncele
                        </Button>
                    </div>
                </div>
                <div className="hidden md:block relative">
                    <GraduationCap size={240} className="text-white/10 rotate-12" />
                    <div className="absolute inset-0 flex items-center justify-center">
                        <Play size={80} className="text-white fill-white drop-shadow-[0_0_30px_rgba(255,255,255,0.5)] cursor-pointer hover:scale-110 transition-transform" />
                    </div>
                </div>
            </div>
        </div>

        {/* SEARCH & FILTER */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 sticky top-24 z-40 bg-[#0B1120]/95 backdrop-blur-xl p-4 rounded-3xl border border-white/5 shadow-2xl">
            <div className="flex gap-2 overflow-x-auto w-full md:w-auto pb-2 md:pb-0 scrollbar-hide">
                {categories.map(cat => (
                    <button
                        key={cat.id}
                        onClick={() => setActiveCategory(cat.id)}
                        className={`px-6 py-3 rounded-2xl text-xs font-black uppercase tracking-widest transition-all whitespace-nowrap ${
                            activeCategory === cat.id 
                            ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/50' 
                            : 'bg-white/5 text-slate-400 hover:bg-white/10 hover:text-white'
                        }`}
                    >
                        {cat.label}
                    </button>
                ))}
            </div>
            
            <div className="relative w-full md:w-96">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
                <Input 
                    placeholder="Eğitim ara..." 
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="h-12 pl-12 bg-black/20 border-white/10 rounded-2xl text-white focus:bg-black/40 transition-all"
                />
            </div>
        </div>

        {/* COURSE GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            <AnimatePresence>
                {filteredCourses.map((course) => (
                    <motion.div
                        key={course.id}
                        layout
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        className="group relative bg-[#0F172A] rounded-[2.5rem] overflow-hidden border border-white/5 hover:border-blue-500/30 transition-all hover:-translate-y-2 hover:shadow-2xl"
                    >
                        {/* Image Cover */}
                        <div className="h-48 overflow-hidden relative">
                            <img src={course.image} alt={course.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] to-transparent"></div>
                            
                            {course.locked && (
                                <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px] flex items-center justify-center">
                                    <div className="bg-black/80 p-3 rounded-full border border-white/10">
                                        <Lock size={24} className="text-white" />
                                    </div>
                                </div>
                            )}

                            <div className="absolute top-4 left-4">
                                <Badge className="bg-black/60 backdrop-blur-md border border-white/10 text-white px-3 py-1 text-[10px] font-black uppercase tracking-widest">
                                    {course.category}
                                </Badge>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="p-6 space-y-4">
                            <h3 className="text-lg font-bold text-white leading-tight group-hover:text-blue-400 transition-colors">
                                {course.title}
                            </h3>
                            
                            <div className="flex items-center justify-between text-xs text-slate-400 font-medium">
                                <div className="flex items-center gap-1">
                                    <Clock size={14} /> {course.duration}
                                </div>
                                <div className="flex items-center gap-1">
                                    <Star size={14} className="text-orange-500 fill-orange-500" /> {course.rating}
                                </div>
                            </div>

                            <div className="pt-4 border-t border-white/5 flex items-center justify-between">
                                <div className="text-xs text-slate-500">
                                    <span className="text-white font-bold">{course.students}</span> Öğrenci
                                </div>
                                <button className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${course.locked ? 'bg-white/5 text-slate-500' : 'bg-blue-600 text-white shadow-lg hover:bg-blue-500'}`}>
                                    {course.locked ? <Lock size={16} /> : <Play size={16} fill="currentColor" />}
                                </button>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>

        {/* EMPTY STATE */}
        {filteredCourses.length === 0 && (
          <div className="text-center py-20">
             <div className="inline-flex p-4 bg-orange-500/10 rounded-full mb-4">
                <SearchX size={32} className="text-orange-500" />
             </div>
             <h3 className="text-xl font-bold text-white mb-2">Sonuç Bulunamadı</h3>
             <p className="text-slate-400">Aramanızla eşleşen eğitim bulunamadı.</p>
          </div>
        )}

      </main>
      <Footer />
    </div>
  );
};

export default AcademyPage;